import { Component, OnInit } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";
import { announcement_condition } from '../class/status';
import { announcement_urltype } from '../class/status';
import { menulist } from '../class/status';
import { page } from '../class/status';
import { chartdata }  from '../class/chatdata';

@Component({
  selector: 'app-shortlink',
  templateUrl: './shortlink.component.html',
  styleUrls: ['./shortlink.component.css']
})
export class ShortlinkComponent implements OnInit {
  replaceArr = ['下架','上架'];

  tcontent = [
    {title:'標題',content:'title'},
    {title:'網址',content:'domain',type:3},
    {title:'Android 點擊數',content:'android_click'},
    {title:'iOS 點擊數',content:'ios_click'},
    {title:'PC 點擊數',content:'web_click'},
    {title:'狀態',content:'is_enable',replaceArr:this.replaceArr},
    {title:'備註',content:'memo'},
    {title:'修改時間',content:'update_dt'},
    {title:'操作',content:'gg',type:3},
  ];

  daily_tcontent = [
    {title:'日期',content:'target_date'},
    {title:'Android 點擊數',content:'android_click'},
    {title:'iOS 點擊數',content:'ios_click'},
    {title:'PC 點擊數',content:'pc_click'},
    {title:'總點擊數',content:'total_click'},
  ];

  Highcharts: typeof Highcharts = Highcharts;
  pageobj:page = {page:0,count:15,total_count:0};
  now:string='0';
  act:string='0';
  menu_list:menulist = [
    {id:'0',name:'短網址設定'},
    {id:'1',name:'每日連結狀態'}
  ];
  show_condition_list:menulist = [{id:'1',name:'日期區間'},{id:'2',name:'觀看次數'},{id:'3',name:'點閱次數'}]
  edit_data:any=[];
  default_data:any={title:'新標題',android_link:'https://supr.link/UtrMF',ios_link:'https://supr.link/UtrMF',web_link:'https://supr.link/UtrMF',memo:'',is_enable:'1',link_text:''};
  data:any=[];
  all_shortlinks:any=[];
  loading:boolean=false;
  tmp_img_b64:{};
  announcement_condition = announcement_condition;
  announcement_urltype = announcement_urltype;
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  constructor(public httpClient: HttpClient,) { }
  enumKeys=[];

  status_filter:string = '';

  // 每日統計相關
  selected_shortlink:string='';
  encodedLabel:string='';
  daily_table_data:any[]=[];
  daily_pageobj:page = {page:0,count:30,total_count:0};
  daily_pageobjstr:string='';
  date_start:string='';
  date_end:string='';
  os_type:string='';

  get daily_display_data():any[]{
    const start = this.daily_pageobj.page * this.daily_pageobj.count;
    return this.daily_table_data.slice(start, start + this.daily_pageobj.count);
  }

  ngOnInit(): void {
    this.init_list();
  }
  lineOptions:Options = JSON.parse(JSON.stringify(chartdata.line));
  updateFlag = false;
  deposit_info:any=[];

  open_add_modal(){
    this.edit_data = JSON.parse(JSON.stringify(this.default_data));
    this.act = '0';
    this.encodedLabel = '';
  }

  updateEncodedLabel(){
    if(this.edit_data && this.edit_data.link_text){
      this.encodedLabel = encodeURIComponent(this.edit_data.link_text);
    } else {
      this.encodedLabel = '';
    }
  }

  save(type:number){
    if(this.edit_data.is_enable == '-1'){
      if(confirm('是否確定刪除')){
        this.update(0);
      }
    } else {
      this.update(0);
    }
  }

  add(){
    this.update(1);
  }

  update(type:number){
    this.loading = true;
    const body = {data:this.edit_data,type:type,gamemode:'0'};
    this.httpClient.post<any>("/update_shortlink_list.php",body).subscribe(res => {
      this.loading = false;
      console.log(res);
      this.init_list();
    });
  }

  init_list(){
    this.loading = true;
    const body:any = {page: this.pageobj.page,count:this.pageobj.count,type:'0'};
    if(this.status_filter !== '') body.is_enable = this.status_filter;
    this.httpClient.post<any>("/get_shortlink_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = Number(res.total_count) || 0;
        this.all_shortlinks = [...this.data];
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });

  }

  encodeLinkText(text:string):string{
    return text ? text.replace(/ /g, '-') : '';
  }

  truncateLinkText(text:string):string{
    return text && text.length > 20 ? text.slice(0, 20) + '...' : (text || '');
  }

  showCopiedToast = false;

  copyLink(item:any){
    const url = 'https://' + item.domain + '/' + item.serial_number + (item.link_text ? '/' + this.encodeLinkText(item.link_text) : '');
    navigator.clipboard.writeText(url).then(() => {
      this.showCopiedToast = true;
      setTimeout(() => this.showCopiedToast = false, 2000);
    });
  }

  private toDateStr(d:Date):string{
    return d.toISOString().slice(0,10);
  }

  private defaultDateRange():{start:string,end:string}{
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 1);
    return {start:this.toDateStr(start), end:this.toDateStr(end)};
  }

  init_daily_view(){
    if(this.all_shortlinks.length === 0){
      this.loading = true;
      const body = {page:0,count:100,type:'0'};
      this.httpClient.post<any>("/get_shortlink_list.php",body).subscribe(res => {
        this.loading = false;
        if(res.status){
          this.all_shortlinks = res.data;
        }
      });
    }
    const range = this.defaultDateRange();
    this.selected_shortlink = '';
    this.date_start = range.start;
    this.date_end = range.end;
    this.os_type = '';
    this.daily_table_data = [];
    this.getchart();
  }

  update_global_chart(){
    let categories = [];
    let android_num:{name:string,type:any,data:any} = {name:'Android點擊數',type:'line',data:[]};
    let ios_num = {name:'iOS點擊數',type:'line',data:[]};
    let pc_num  = {name:'PC點擊數',type:'line',data:[]};
    let all_num = {name:'註冊數',type:'line',data:[]};

    this.deposit_info.forEach((v)=>{
      categories.push(v.target_date);
      all_num.data.push(v.regist*1);
      android_num.data.push(0);
      ios_num.data.push(0);
      pc_num.data.push(0);
    });

    this.lineOptions.title = {text:'全部連結每日點擊數分布'};
    this.lineOptions.xAxis = {categories:categories};
    this.lineOptions.series = [android_num,ios_num,pc_num,all_num];
    this.updateFlag = true;
    this.daily_table_data = [];
  }

  choose(value:string){
    this.now = value;
    this.pageobj.page = 0;
    if(value === '1'){
      this.init_daily_view();
    } else {
      this.init_list();
    }
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  getchart(value?:string){
    const id = value !== undefined ? value : this.selected_shortlink;
    const body:any = {type:1};
    if(id) body.short_link_id = id;
    if(this.date_start) body.date_start = this.date_start;
    if(this.date_end) body.date_end = this.date_end;
    if(this.os_type) body.os_type = this.os_type;

    this.loading = true;
    this.httpClient.post<any>("/get_shortlink_list.php",body).subscribe(res => {
      this.loading = false;
      this.daily_table_data = [];

      if(!res.status || !res.data){
        this.lineOptions.title = {text:'點擊數分布'};
        this.lineOptions.series = [];
        this.updateFlag = true;
        return;
      }

      const rawData = res.data;
      const targetKeys = id ? [id] : Object.keys(rawData);
      const dateData:{[date:string]:{android:number;ios:number;pc:number}} = {};

      targetKeys.forEach(linkId => {
        const linkDates = rawData[linkId] || {};
        Object.entries(linkDates).forEach(([date,counts]:[string,any]) => {
          if(!dateData[date]) dateData[date] = {android:0,ios:0,pc:0};
          dateData[date].android += Number(counts.android)||0;
          dateData[date].ios += Number(counts.ios)||0;
          dateData[date].pc += Number(counts.pc)||0;
        });
      });

      const chartCategories = Object.keys(dateData).sort();
      const tableCategories = [...chartCategories].reverse();

      this.lineOptions.title = {text: id ? '指定連結每日點擊數' : '全部連結每日點擊數'};
      this.lineOptions.xAxis = {categories: chartCategories};

      const allSeries = [
        {name:'Android點擊數',type:'line' as any,key:'android',data:chartCategories.map(d=>dateData[d].android)},
        {name:'iOS點擊數',    type:'line' as any,key:'ios',    data:chartCategories.map(d=>dateData[d].ios)},
        {name:'PC點擊數',     type:'line' as any,key:'pc',     data:chartCategories.map(d=>dateData[d].pc)},
      ];
      this.lineOptions.series = this.os_type
        ? allSeries.filter(s => s.key === this.os_type).map(({key,...s})=>s)
        : allSeries.map(({key,...s})=>s);
      this.updateFlag = true;

      this.daily_table_data = tableCategories.map(date => ({
        target_date: date,
        android_click: dateData[date].android,
        ios_click: dateData[date].ios,
        pc_click: dateData[date].pc,
        total_click: this.os_type
          ? (dateData[date][this.os_type] || 0)
          : dateData[date].android + dateData[date].ios + dateData[date].pc,
      }));
      this.daily_pageobj = {page:0, count:30, total_count:this.daily_table_data.length};
      this.daily_pageobjstr = JSON.parse(JSON.stringify(this.daily_pageobj));
    });
  }

  query_daily(){
    this.getchart();
  }

  daily_callback(pageobj:page){
    if(JSON.stringify(this.daily_pageobj) !== JSON.stringify(pageobj)){
      this.daily_pageobj = pageobj;
      this.daily_pageobjstr = JSON.parse(JSON.stringify(pageobj));
    }
  }

  view_daily(id: string){
    this.now = '1';
    if(this.all_shortlinks.length === 0){
      this.loading = true;
      const body = {page:0,count:100,type:'0'};
      this.httpClient.post<any>("/get_shortlink_list.php",body).subscribe(res => {
        this.loading = false;
        if(res.status) this.all_shortlinks = res.data;
      });
    }
    const range = this.defaultDateRange();
    this.selected_shortlink = id;
    this.date_start = range.start;
    this.date_end = range.end;
    this.os_type = '';
    this.daily_table_data = [];
    this.getchart(id);
  }
}
